"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterStacktrace = filterStacktrace;
exports.formatStacktrace = formatStacktrace;
exports.startMobxDebugging = startMobxDebugging;
const mobx_1 = require("mobx");
const adapter_1 = require("../../api/adapter");
const testLibPath = /.*(bootstrap.*|node_modules.*|disposable\.ts)$/;
function replacePath(path) {
    var _a;
    const parts = path.split("/");
    let first = null;
    while (first !== "src" && parts.length > 1) {
        first = (_a = parts.shift()) !== null && _a !== void 0 ? _a : null;
    }
    if (first === "src") {
        parts.unshift(first);
    }
    return `/${parts.join("/")}`;
}
/**
 * Removes from a stacktrace internal frames like React calls
 */
function filterStacktrace(stacktrace) {
    return stacktrace
        .filter((f) => { var _a; return !testLibPath.test((_a = f.fileName) !== null && _a !== void 0 ? _a : ""); })
        .map((f) => { var _a; return ({ ...f, fileName: replacePath((_a = f.fileName) !== null && _a !== void 0 ? _a : "<unknown>") }); });
}
/**
 * Formats a stacktrace to a readable text string
 */
function formatStacktrace(stacktrace, filenames = true) {
    if (filenames) {
        return filterStacktrace(stacktrace)
            .map((f) => `\tat ${f.functionName} (${f.fileName}:${f.lineNumber})`)
            .join("\n");
    }
    return stacktrace.map((f) => `\tat ${f.functionName}`).join("\n");
}
const exclude = ["name", "type", "spyReportStart", "debugObjectName", "observableKind"];
function startMobxDebugging() {
    const mobxDebug = adapter_1.device.isImplements(adapter_1.Feature.LOCAL_STORAGE) ? adapter_1.device.localStorage.getItem("mobxDebug") : "";
    if (mobxDebug === "true" || mobxDebug === "flat") {
        const useGroups = mobxDebug !== "flat";
        const oldDisposer = adapter_1.device.globals.get("mobxSpyDisposer");
        if (typeof oldDisposer === "function") {
            oldDisposer();
        }
        const mobxSpyDisposer = (0, mobx_1.spy)((event) => {
            var _a, _b;
            let type = event.type;
            let name = (_a = event.name) !== null && _a !== void 0 ? _a : "";
            switch (type) {
                case "action":
                    if (typeof event.object === "object") {
                        name = `${event.object.constructor.name}.${name}`;
                    }
                    break;
                case "add":
                case "delete":
                case "create":
                case "remove":
                case "splice":
                case "update":
                    name = (_b = (event.name == null ? event.debugObjectName : `${event.debugObjectName}.${event.name}`)) !== null && _b !== void 0 ? _b : "";
                    break;
                default:
            }
            if (name.startsWith("event:")) {
                type = `event ${type}`;
                name = name.slice(6);
            }
            if (event.observableKind) {
                name = `${event.observableKind} ${name}`;
            }
            const other = Object.entries(event).filter(([k, v]) => !exclude.includes(k));
            if (event.spyReportStart) {
                if (useGroups) {
                    console.groupCollapsed(type, name);
                    console.groupCollapsed("stacktrace");
                    console.trace();
                    console.groupEnd();
                }
                else {
                    console.log(`%c${event.type}`, "font-weight: bold", name, Object.fromEntries(other));
                }
            }
            else if (event.type === "report-end") {
                if (useGroups) {
                    console.groupEnd();
                }
                return;
            }
            else {
                console.log(`%c${event.type}`, "font-weight: bold", name);
            }
            if (useGroups && other.length > 0) {
                console.log(Object.fromEntries(other));
            }
        });
        adapter_1.device.globals.set("mobxSpyDisposer", mobxSpyDisposer);
    }
}
//# sourceMappingURL=debug.js.map